export const prime = {
  prime: 'prime/',
  customer: 'customer/',
  customerEndpoint: 'customerEndpoint/',
  cart: 'prime-cart',
  cancel: 'prime-cancel',
  subscription: 'customerEndpoint/v2/prime-subscription',
  creditCard: 'crm/v3/customer/creditCard/prime/',
  getPrivacyInfo : 'getPrivacyInfo',
  subscriptionFree: 'customerEndpoint/prime-subscription',
  primeStrip :'_ah/v2/api/customer/prime',
  getTerms: 'config/r/CO/v1/property/TERMS_CMS_18',
};
